import { toast } from 'react-toastify';

let isToastConfirmOpen = false;
export const toastConfirm = ({ message = "Are you sure?", onConfirm }) => {

  if (isToastConfirmOpen) return;

  isToastConfirmOpen = true;

  toast(
    ({ closeToast }) => (
      <div>
        <p>{message}</p>
        <div style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
          <button
            className="btn btn-sm btn-danger"
            onClick={async () => {
              await onConfirm();
              closeToast();
              isToastConfirmOpen = false;
            }}
          >
            Yes
          </button>
          <button
            className="btn btn-sm btn-secondary"
            onClick={()=> {
              closeToast();
              isToastConfirmOpen = false;
            }
            }
          >
            No
          </button>
        </div>
      </div>
    ),
    {
      autoClose: true,
      closeOnClick: true,
      closeButton: true,
      onClose: () => {
        isToastConfirmOpen = false;
      },
    }
  );
};
